"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var utils_1 = require("../../context/columns/utils");
var constants_1 = require("../../constants");
var getWidthColumns = function (items, amountItems) { return items.reduce(function (acc, _a) {
    var _b;
    var id = _a.id;
    return (__assign(__assign({}, acc), (_b = {}, _b[id] = 1 / amountItems, _b)));
}, {}); };
var useStateColumnsWidth = function (columnsState) {
    var visibleColumns = (0, react_1.useMemo)(function () { return (0, utils_1.getVisibleColumns)(columnsState); }, [columnsState]);
    var amountVisibleColumns = (0, react_1.useMemo)(function () { return visibleColumns.length; }, [visibleColumns]);
    var _a = (0, react_1.useState)(function () { return getWidthColumns(visibleColumns, amountVisibleColumns); }), stateColumnsWidth = _a[0], setStateColumnsWidth = _a[1];
    var handlerColumnWidth = (0, react_1.useCallback)(function (_a) {
        var _b;
        var columnId = _a.columnId, columnIndex = _a.columnIndex, deltaX = _a.deltaX, width = _a.width;
        var nextColumnId = (visibleColumns[columnIndex + 1]
            || visibleColumns[columnIndex - 1] || {}).id;
        var percentDelta = deltaX / width;
        var widthColumn = stateColumnsWidth[columnId] + percentDelta;
        var nextWidthColumn = stateColumnsWidth[nextColumnId] - percentDelta;
        if (widthColumn < stateColumnsWidth[columnId]
            && widthColumn * width < constants_1.MIN_ROW_WIDTH)
            return undefined;
        if (nextWidthColumn < stateColumnsWidth[nextColumnId]
            && nextWidthColumn * width < constants_1.MIN_ROW_WIDTH)
            return undefined;
        setStateColumnsWidth(__assign(__assign({}, stateColumnsWidth), (_b = {}, _b[columnId] = widthColumn, _b[nextColumnId] = nextWidthColumn, _b)));
        return null;
    }, [visibleColumns, stateColumnsWidth, setStateColumnsWidth]);
    return { stateColumnsWidth: stateColumnsWidth, handlerColumnWidth: handlerColumnWidth };
};
exports.default = useStateColumnsWidth;
